import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import * as _ from 'lodash';
import { ConstructionService } from '@app/cp/shared/services/construction.service';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { ConstructionSearchParam } from '@app/cp/shared/models/ConstructionSearchParam';
import { aggregateBy } from '@progress/kendo-data-query';
import { Subscription, Observable } from 'rxjs';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { Message } from '@app/cp/shared/models/message';
import { SearchTarget } from '@app/cp/shared/enums/SearchTarget';
import { DQOIParam } from '@app/cp/shared/models/DQOIParam';
import { MessageType } from '@app/cp/shared/enums/MessageType';
import { RefreshToken } from '@app/cp/shared/models/RefreshToken';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';
interface ColumnSetting {
    field: string;
    title: string;
    format?: string;
    class?: string;
    type: 'text' | 'numeric' | 'boolean' | 'date';
    hidden: boolean;

}

@UseFeatureFlagSet()
@Component({
    selector: 'job-draws',
    templateUrl: './job-draws.component.html',
    styleUrls: ['./job-draws.component.scss'],
    standalone: false
})
export class JobDrawsComponent extends BaseGridUIComponent<any, null, ConstructionService> {
    compFeatureFlagSet: IFeatureFlagSet = this as any;
    public aggregates: any[] = [];
    public aggregateResults;
    public dynamicAggregateResults;
    public dynamicAggregates: any[] = [];

    constructor(globals: GlobalsService, private svc_construction: ConstructionService, private svc_dispatch: DispatchesService) {
        super(globals);
        this.svc_construction = svc_construction;

        this.aggregates = [
            { field: 'totalDraw', aggregate: 'sum' },
            { field: 'totalPayments', aggregate: 'sum' },
            { field: 'laborCost', aggregate: 'sum' },
            { field: 'matCost', aggregate: 'sum' },
            { field: 'otherCost', aggregate: 'sum' },
            { field: 'tax', aggregate: 'sum' },
            { field: 'useTax', aggregate: 'sum' },
            { field: 'totalCost', aggregate: 'sum' },
            { field: 'profit', aggregate: 'sum' },
            { field: 'totalBeforeRet', aggregate: 'sum' },
            { field: 'ret', aggregate: 'sum' }
        ];
    }

//    @Input() contractId: string;

    paymentsToDate: number = 0.00;
    drawsWithRet: number = 0.00;
    totRet: number = 0.00;
    drawsLessRet: number = 0.00;

    gridDynamicDataPrime: any[] = [];
    rawDynData: BaseMessageInfo;
    NTEGridData: any[] = [];
    TaxGridData: any[] = [];
    dynamicLoading: boolean = true;
    ColumnHeaders: ColumnSetting[];
    StaticColumnHeaders: ColumnSetting[];
    DynamicColumnHeaders: ColumnSetting[];

    constSearchParam: ConstructionSearchParam = new ConstructionSearchParam();

    ngOnDestroy() {
        CommonFunctions.unsubscribe(this.refreshSubs);
    }
    ngOnInit() {
        this.getData();

        if (this.svc_construction) {
            this.refreshSubs = this.svc_construction.refreshSubject.subscribe((token: RefreshToken) => {
                this.refreshData(token);
            });
        }
    }

    refreshSubs: Subscription;
    refreshData(token: RefreshToken) {

        if (token.all) {
            this.getData();
        }
    }

    findAggregates(cat: string) {
        let filtered = this.rawDynData.primaryReturn.filter(function (value, index, arr) { return value.cat === cat; });
        let values = filtered.map(a => a.amount);

        var iter = (acc, tot) => {

            if (tot && Math.abs(tot) > 0) { return acc + tot; }
            else { return acc; }
        }
        let retVal = values.reduce(iter, 0);

        return Math.abs(retVal) > 0 ? retVal : 0.00;
    }
    getData() {
        if (this._id) {
            this.constSearchParam.contractId = this._id;
            this.svc_construction.GetJobDrawsByContractId(this.constSearchParam).subscribe((data: BaseMessageInfo) => {
                if (!data.warning) {
                    this.ListData = data.primaryReturn;

                    this.processGridData();
                    this.calcTotals();
                }

                if (data.warning) {
                    //alert('data.warning');
                }
            });
            this.dynamicLoading = true;
            this.gridDynamicDataPrime = [];
            this.svc_construction.GetDynamicJobDrawsByContractId(this.constSearchParam).subscribe((dynData: BaseMessageInfo) => {

                if (dynData && dynData.primaryReturn && dynData.primaryReturn.length > 0 && !dynData.warning) {

                    this.rawDynData = _.cloneDeep(dynData);
                    //let filtered = dynData.primaryReturn.filter(function (value, index, arr) { return value.billingTypeName != 'NTE' && value.billingTypeName != 'TAX' && value.billingTypeName != 'LabNTE' && value.billingTypeName != 'OthNTE' && value.billingTypeName != 'MatNTE'; });
                    let filtered = dynData.primaryReturn.filter(function (value, index, arr) { return ['NTE','TAX','LabNTE','MatNTE','OthNTE','LabTAXBIL','MatTAXBIL','OthTAXBIL','LabTAXBID','MatTAXBID','OthTAXBID'].indexOf(value.billingTypeName) == -1 });
                    this.NTEGridData = this.compressNTEData(dynData.primaryReturn.filter(function (value, index, arr) { return value.billingTypeName === 'NTE'; }))
                        .sort((a, b) => (a.accountClassName < b.accountClassName) ? -1 : (a.accountClassName > b.accountClassName) ? 1 : 0);
                        //.sort((a, b) => (a.cat < b.cat) ? -1 : (a.cat > b.cat) ? 1 : 0);
                    this.TaxGridData = this.compressNTEData(dynData.primaryReturn.filter(function (value, index, arr) { return value.billingTypeName === 'TAX'; }))
                        .sort((a, b) => (a.accountClassName < b.accountClassName) ? -1 : (a.accountClassName > b.accountClassName) ? 1 : 0);
                        //.sort((a, b) => (a.cat < b.cat) ? -1 : (a.cat > b.cat) ? 1 : 0);

                    //let newAggregates = this.populateDynamicAggregates(dynData.primaryReturn);
                    //this.dynamicAggregates = this.dynamicAggregates.concat(newAggregates);
                    let newAggregates = this.populateDynamicAggregates(filtered);
                    this.dynamicAggregates = newAggregates;

                    this.gridDynamicDataPrime = this.processDynamicDataForGrid(filtered);
                    if (this.gridDynamicDataPrime.length < 1) {
                        this.gridDynamicDataPrime = [{ "invoiceNumber": "No Invoices" }];
                        this.DynamicColumnHeaders.forEach((element, index) => { this.gridDynamicDataPrime[0][element.field] = 0 });
                    }

                    //this.setColumnHiddenStatus();
                    this.processDynamicGridData();
                    this.dynamicLoading = false;

                } else {
                    this.dynamicLoading = false;
                }
            });
        }
    }

    populateDynamicAggregates(data) {
        var iter = function (dynAggregates, record) {
            let fieldName = '';
            if (record.cat && record.cat != '') {
                fieldName = (record.cat ? record.cat : '');
                let index = dynAggregates.findIndex((element) => { return element.field === fieldName });
                if (index > -1) {
                    dynAggregates = dynAggregates;
                } else if (record.cat && record.cat != '') {
                    let newFieldName = (record.cat ? record.cat : '');
                    dynAggregates.push({
                        field: newFieldName,
                        aggregate: 'sum'
                    }
                    );
                }
            }
            return dynAggregates;
        };
        return data.reduce(iter, [])
    }

    processDynamicDataForGrid(data: any) {
        let pivoted = this.pivotData(data);
        pivoted = this.PopulateZeros(pivoted);
        pivoted.sort((a, b) => {
            let aStr = a.invoiceNumber.split("-");
            let aPos = parseInt(aStr[1] ? aStr[1] : 0);
            let bStr = b.invoiceNumber.split("-");
            let bPos = parseInt(bStr[1] ? bStr[1] : 0);
            return ((aPos < bPos) ? -1 : ((aPos > bPos) ? 1 : 0));
        });

        this.ColumnHeaders = this.getColumnHeaders(pivoted);

        this.StaticColumnHeaders = this.getStaticColumnHeaders(this.ColumnHeaders);
        this.DynamicColumnHeaders = this.getDynamicColumnHeaders(this.ColumnHeaders);
        if (true) {//(this.gridDynamicDataPrime.length < 1) {//(this.DynamicColumnHeaders.length < 1) {
            let test = this.rawDynData.primaryReturn.filter(function (value, index, arr) { return value.billingTypeName.includes('NTE') && value.billingTypeName != 'NTE'; });

            let NTEColumns = this.compressNTEData(test)
                .sort((a, b) => (a.accountClassName < b.accountClassName) ? -1 : (a.accountClassName > b.accountClassName) ? 1 : 0);

            let testColumns = this.getColumnHeaders(NTEColumns);

            let extraDynamicColumnHeaders = this.generateDynamicColumnHeadersForEmptyData(testColumns);

            for (let i = 0; i < extraDynamicColumnHeaders.length; i++) {
                extraDynamicColumnHeaders[i].field = extraDynamicColumnHeaders[i].field.substring(0, extraDynamicColumnHeaders[i].field.length - 3);
                extraDynamicColumnHeaders[i].title = extraDynamicColumnHeaders[i].title.substring(0, extraDynamicColumnHeaders[i].title.length - 3);
            }

            //filter existing dynamic Headers out of the extras
            let filteredExtra = extraDynamicColumnHeaders;
            if (this.DynamicColumnHeaders.length > 0) {
                let existingHeaders = this.DynamicColumnHeaders.map(s => s.field);
                filteredExtra = extraDynamicColumnHeaders.filter(function (value, index, arr) { return existingHeaders.indexOf(value.field) == -1 });
            }

            filteredExtra.forEach((extra) => {
                this.DynamicColumnHeaders.push(extra);
            });

            //if (this.gridDynamicDataPrime.length < 1) {
            //    pivoted = [{ "invoiceNumber": "No Invoices" }];
            //    this.DynamicColumnHeaders.forEach((element, index) => { pivoted[0][element.field] = 0 });
            //}

        }

        return pivoted;
    }

    pivotData(data) {
        //let test = [];
        var iter = function (pivoted, record) {
            let index = pivoted.findIndex((element) => { return element.invoiceId === record.invoiceId });
            if (index > -1 && record.cat && record.cat != '') {
                pivoted[index][(record.cat ? record.cat : '')] = record.amount;
            } else if (record.cat && record.cat != '') {
                pivoted.push({
                    invoiceNumber: record.invoiceNumber,
                    [(record.cat ? record.cat : '')]: record.amount,
                    accountClassName: record.accountClassName,
                    billingTypeName: record.billingTypeName,
                    invoiceId: record.invoiceId,
                    accountClassId: record.accountClassId,
                    billingTypeId: record.billingTypeId
                });
            } else {
                pivoted.push({
                    invoiceNumber: record.invoiceNumber,
                    accountClassName: record.accountClassName,
                    billingTypeName: record.billingTypeName,
                    invoiceId: record.invoiceId,
                    accountClassId: record.accountClassId,
                    billingTypeId: record.billingTypeId
                });
            }

            return pivoted;
        };

        return data.reduce(iter, [])
    }

    compressNTEData(data) {
        //let test = [];
        var iter = function (pivoted, record) {
            let index = pivoted.findIndex((element) => { return element.accountClassId === record.accountClassId });
            if (index > -1 && record.cat && record.cat != '') {
                pivoted[index][(record.cat ? record.cat : '')] += record.amount;
                pivoted[index].amount = pivoted[index].amount + record.amount;
            } else if (record.cat && record.cat != '') {
                pivoted.push({
                    invoiceNumber: record.invoiceNumber,
                    amount: record.amount,
                    [(record.cat ? record.cat : '')]: record.amount,
                    accountClassName: record.accountClassName,
                    billingTypeName: record.billingTypeName,
                    invoiceId: record.invoiceId,
                    accountClassId: record.accountClassId,
                    billingTypeId: record.billingTypeId
                });
            } else {
                pivoted.push({
                    invoiceNumber: record.invoiceNumber,
                    amount: record.amount,
                    accountClassName: record.accountClassName,
                    billingTypeName: record.billingTypeName,
                    invoiceId: record.invoiceId,
                    accountClassId: record.accountClassId,
                    billingTypeId: record.billingTypeId
                });
            }

            return pivoted;
        };

        return data.reduce(iter, [])
    }

    PopulateZeros(data) {
        data.forEach((row) => {
            this.dynamicAggregates.forEach((agg) => {
                if (!row[agg.field]) {
                    row[agg.field] = 0;
                }
            });
        });
        return data;
    }

    public getColumnHeaders(data) {

        var iter = function (columns, record) {
            let keys = Object.keys(record);
            keys.forEach((key) => {

                if (columns.findIndex((column) => { return column.field === key }) == -1) {

                    let columnSettings: ColumnSetting = {
                        field: key,
                        title: key,
                        format: 'c2',
                        class: record.accountClassName,
                        type: 'text',
                        hidden: false
                    };

                    columns.push(columnSettings);
                }
            });

            return columns;
        };

        return data.reduce(iter, [])
    }

    public getStaticColumnHeaders(data) {
        var iter = function (columns, record) {
            let staticColumns: any = ['invoiceNumber', 'accountClassName', 'billingTypeName', 'invoiceId', 'accountClassId', 'billingTypeId'];
            if (columns.findIndex((column) => { return column.field === record.field }) == -1 && staticColumns.findIndex((entry) => { return entry === record.field }) != -1) {

                let columnSettings: ColumnSetting = {
                    field: record.field,
                    title: record.field,
                    format: 'c2',
                    type: 'text',
                    hidden: false
                };
                columns.push(columnSettings);
            }
            return columns;
        };

        return data.reduce(iter, [])
    }

    public getDynamicColumnHeaders(data) {
        var iter = function (columns, record) {
            let staticColumns: any = ['invoiceNumber', 'accountClassName', 'billingTypeName', 'invoiceId', 'accountClassId', 'billingTypeId'];
            if (columns.findIndex((column) => { return column.field === record.field }) == -1 && staticColumns.findIndex((entry) => { return entry === record.field }) == -1) {

                let columnSettings: ColumnSetting = {
                    field: record.field,
                    title: record.field,
                    format: 'c2',
                    class: record.field.substring(0,3),
                    type: 'text',
                    hidden: false
                };
                columns.push(columnSettings);
            }
            return columns;
        };

        return data.reduce(iter, []).sort((a, b) => (a.field < b.field) ? -1 : (a.field > b.field) ? 1 : 0);
    }

    public generateDynamicColumnHeadersForEmptyData(data) {
        var iter = function (columns, record) {
            let staticColumns: any = ['invoiceNumber', 'accountClassName', 'billingTypeName', 'invoiceId', 'accountClassId', 'billingTypeId', 'amount'];
            if (columns.findIndex((column) => { return column.field === record.field }) == -1 && staticColumns.findIndex((entry) => { return entry === record.field }) == -1) {

                let columnSettings: ColumnSetting = {
                    field: record.field,
                    title: record.field,
                    format: 'c2',
                    class: record.field.substring(0, 3),
                    type: 'text',
                    hidden: false
                };
                columns.push(columnSettings);
            }
            return columns;
        };

        return data.reduce(iter, []).sort((a, b) => (a.field < b.field) ? -1 : (a.field > b.field) ? 1 : 0);
    }

    SortDynamicColumns(data) {
        let sorted = data;
        return sorted;
    }

    public getColumnHiddenStatus(column: string) {
        let hidden: boolean = false;
        switch (column) {
            case ("accountClassName"):
            case ("billingTypeName"):
            case ("invoiceId"):
            case ("accountClassId"):
            case ("billingTypeId"):
                hidden = true;
                break;
            default:
                hidden = false;
        }
        return hidden;
    }

    public setColumnHiddenStatus() {
        this.ColumnHeaders.forEach((column) => {
            switch (column.title) {
                case ("accountClassName"):
                case ("billingTypeName"):
                case ("invoiceId"):
                case ("accountClassId"):
                case ("billingTypeId"):
                    column.hidden = true;
                    break;
                default:
                    column.hidden = false;
            }
        });

    }

    calcTotals() {
        this.paymentsToDate = 0;
        this.drawsWithRet = 0;
        this.totRet = 0;
        this.drawsLessRet = 0;

        if (this.gridData) {
            this.gridData.forEach(i => {
                this.paymentsToDate += i.totalPayments;
                if (i.ret > 0) {
                    this.drawsWithRet += i.ret;
                    this.totRet += i.ret;
                    this.drawsLessRet += i.totalDraw;
                }
            });
            this.drawsLessRet = this.drawsLessRet - this.totRet;
        }
    }

    processGridData() {
        if (CommonFunctions.hasArrayElementValue(this.gridData)) {
            this.aggregateResults = aggregateBy(this.gridData, this.aggregates);

        }
    }

    processDynamicGridData() {
        if (CommonFunctions.hasArrayElementValue(this.gridDynamicDataPrime)) {
            this.dynamicAggregateResults = aggregateBy(this.gridDynamicDataPrime, this.dynamicAggregates);

        }
    }

    getColumnLastIndex(input) {
        return this.DynamicColumnHeaders.map(s => s.class).lastIndexOf(input) + 1;
    }

    getColumnFirstIndex(input) {
        return this.DynamicColumnHeaders.map(s => s.class).indexOf(input) + 1;
    }

    getNTEIndex(input) {
        return this.NTEGridData.map(s => s.accountClassName.substring(0, 3)).lastIndexOf(input) + 1;
    }

    getTaxIndex(input) {
        return this.TaxGridData.map(s => s.accountClassName.substring(0, 3)).lastIndexOf(input) + 1;
    }

    getDynamicAggregateResultsTotals(start, end) {
        var total = 0;
        for (var i = start; i <= end; i++) {
            total += (this.DynamicColumnHeaders[i].field && this.dynamicAggregateResults && this.dynamicAggregateResults[this.DynamicColumnHeaders[i].field].sum) ? this.dynamicAggregateResults[this.DynamicColumnHeaders[i].field].sum : 0;
        }
        return total;
    }
}
